import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/core/shared/http.service';
import { ScenarioControl } from '../interfaces/ScenarioControl.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManualControlService {

  constructor(private httpService: HttpService) { }

  public createManualControl(data: ScenarioControl): Observable<ScenarioControl> {
    return this.httpService.post<ScenarioControl>('ScenarioControl', data);
  }

  public getManualControlById(id: number): Observable<ScenarioControl> {
    return this.httpService.get<ScenarioControl>('ScenarioControl/' + id);
  }

  public updateManualControl(data: ScenarioControl): Observable<ScenarioControl> {
    return this.httpService.put<ScenarioControl>('ScenarioControl/' + data.id, data);
  }

  public deleteManualControl(id: number): Observable<void> {
    return this.httpService.delete<void>('ScenarioControl/' + id);
  }
}
